<div *ngIf="inventoryTransferModalIsOpen" class="inventory-transfer-modal">
  <div class="h-100">
    <a href="#" class="icon close" (click)="handleClose(); $event.preventDefault()"
      ><img src="/assets/images/icon/close.svg"
    /></a>
    <div class="row h-100">
      <div class="col-12 col-lg-6">
        <div class="p-5 h-100">
          <p class="title">Select Tools to Transfer</p>
          <app-tool-inventory-id-transfer-search #inventoryIdSearch></app-tool-inventory-id-transfer-search>
          <app-tool-inventory-transfer-search #inventorySearch></app-tool-inventory-transfer-search>
          <div class="selected">
            <div class="d-flex justify-content-between align-items-center">
              <p>
                <strong>Selected Tools ({{ tableData.data.length }})</strong>
                <span>Check tools to include in a transfer.</span>
              </p>
              <button (click)="handleClear()">Clear</button>
            </div>
            <app-tool-settings-table
              class="scroll"
              [headers]="tableData"
              [rows]="tableData.data"></app-tool-settings-table>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 border-left">
        <div class="p-5 h-100">
          <p class="title small">Choose Where You Want to Transfer Tools</p>
          <p class="body">
            You can transfer selected tools to another job, employee, location, or shop. This action is will update all
            tools chosen.
          </p>
          <app-tool-inventory-transfer-assignment></app-tool-inventory-transfer-assignment>
        </div>
      </div>
    </div>
  </div>
</div>
